import React, { useEffect, useState } from "react";

export default function Typewriter({ text, speed = 42, startDelay = 900, className = "" }) {
  const [shown, setShown] = useState("");
  const [done, setDone] = useState(false);

  useEffect(() => {
    let i = 0;
    let timer;
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce) {
      setShown(text);
      setDone(true);
      return;
    }
    const startTimer = setTimeout(() => {
      timer = setInterval(() => {
        i += 1;
        setShown(text.slice(0, i));
        if (i >= text.length) {
          clearInterval(timer);
          setDone(true);
        }
      }, speed);
    }, startDelay);
    return () => {
      clearTimeout(startTimer);
      clearInterval(timer);
    };
  }, [text, speed, startDelay]);

  return (
    <span className={className} aria-label={text}>
      {shown}
      <span className="tw-cursor" style={{ opacity: done ? 0.9 : 1 }} />
    </span>
  );
}
